var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { AliasTable, aliasLabel, collectVersionOpHashes, isAliasScope, resolveAliasTarget, rootNameForVersionHash, } from "@hyper-hyper-space/hhs3_rdb_runtime";
import { formatDisplayString, formatSessionRows } from "./format/display.js";
export { AliasTable, aliasLabel, collectVersionOpHashes, isAliasScope, resolveAliasTarget, rootNameForVersionHash, };
export function formatAliasResult(scope, name, hash, session) {
    return __awaiter(this, void 0, void 0, function* () {
        const label = yield aliasLabel(scope, hash, session);
        const suffix = label === undefined ? '' : ` (${label})`;
        return `${scope} ${name} => ${formatDisplayString(session, hash, { role: 'hash' })}${suffix}`;
    });
}
export function formatAliasListing(session, scope) {
    return __awaiter(this, void 0, void 0, function* () {
        const rows = yield Promise.all(session.aliases.list(scope).map((entry) => __awaiter(this, void 0, void 0, function* () {
            var _a;
            return ({
                scope: entry.scope,
                name: entry.name,
                hash: entry.hash,
                label: (_a = (yield aliasLabel(entry.scope, entry.hash, session))) !== null && _a !== void 0 ? _a : '',
            });
        })));
        return formatSessionRows(session, rows, undefined, { structuralColumns: new Set(['hash']) });
    });
}
